
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/phonics-practice/[curriculum]/[targetSound]",
      function () {
        return require("private-next-pages/phonics-practice/[curriculum]/[targetSound].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/phonics-practice/[curriculum]/[targetSound]"])
      });
    }
  